





































































































import { Component, Vue } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';
import { CustomerBillingModel } from '@/app/shared/models';
import DialogConfirmBlacklistComponent from '@/app/shared/components/dialogs/confirm-blacklist.vue';
import { NotifyType } from '@/app/shared/enums/notify/notify-type.enum';

@Component({
  components: { DialogConfirmBlacklistComponent },
})
export default class ContentCustomerBillingComponent extends Vue {
  private blacklistEmail = false;
  private blacklistPhoneSms = false;
  private blacklistPhoneWhatsapp = false;
  private blacklistPhoneRcs = false;
  private blacklistCellPhoneSms = false;
  private blacklistCellPhoneWhatsapp = false;
  private blacklistCellPhoneRcs = false;
  private dialogBlacklist = true;
  private dataEmail = { Value: '', MessageType: NotifyType.Email };
  private dataPhoneSms = { Value: '', MessageType: NotifyType.Sms };
  private dataPhoneWhatsapp = { Value: '', MessageType: NotifyType.Whatsapp };
  private dataPhoneRcs = { Value: '', MessageType: NotifyType.Rcs };
  private dataCellPhoneSms = { Value: '', MessageType: NotifyType.Sms };
  private dataCellPhoneWhatsapp = {
    Value: '',
    MessageType: NotifyType.Whatsapp,
  };
  private dataCellPhoneRcs = { Value: '', MessageType: NotifyType.Rcs };
  private get refs() {
    return refsService;
  }

  private async mounted() {
    this.$bus.$on('closeDialogBlacklist', async () => {
      this.blacklistEmail = await this.emailBlacklist();
      await this.phoneBlacklist();
      await this.cellPhoneBlacklist();
    });
    this.blacklistEmail = await this.emailBlacklist();
    await this.phoneBlacklist();
    await this.cellPhoneBlacklist();
  }
  private get customer(): CustomerBillingModel {
    return this.refs.modules.contract.customer;
  }
  private get email() {
    return this.refs.util.findEmail(this.customer.Contacts);
  }
  private get phones() {
    const phones = this.refs.util.findPhones(this.customer.Contacts);
    return phones;
    // ? this.refs.util.createMask(phones.Value, '(##) #####-####')
    // : undefined;
  }
  private get cellphones() {
    const cellphones = this.refs.util.findCellPhones(this.customer.Contacts);
    return cellphones;
    // ? this.refs.util.createMask(phones.Value, '(##) #####-####')
    // : undefined;
  }
  private get phone() {
    const phone = this.refs.util.findPhone(this.customer.Contacts);
    return phone
      ? this.refs.util.createMask(phone.Value, '(##) ####-####')
      : undefined;
  }
  private get cellPhone() {
    const cellPhone = this.refs.util.findCellphone(this.customer.Contacts);
    return cellPhone
      ? this.refs.util.createMask(cellPhone.Value, '(##) #####-####')
      : undefined;
  }
  private get document() {
    return this.customer.DocumentType && this.customer.Document
      ? `${this.customer.DocumentType} - ${this.refs.util.createMask(
          this.customer.Document,
          this.customer.DocumentType == 'CPF'
            ? '###.###.###-##'
            : '##-###-###/####-##'
        )}`
      : this.customer.DocumentType || this.customer.Document || '--';
  }
  private get address() {
    const address = this.refs._.head(this.customer.Addresses);
    return address
      ? `${address.Street || '--'},
      ${address.Neighborhood || '--'},
      ${address.Complement || '--'},
      ${address.Number || '--'},
      ${address.City || '--'},
      ${address.SubdivisionCode || '--'},
      ${
        address.PostalCode
          ? this.refs.util.createMask(address.PostalCode, '##.###-###')
          : '--'
      }`
      : undefined;
  }
  public async emailBlacklist() {
    if (this.email?.Value) {
      const data = {
        Address: this.email.Value,
        MessageType: NotifyType.Email,
      };
      const result = await this.refs.modules.notify.BlacklistExists(data);
      if (result) {
        this.dataEmail.Value = this.email.Value;
      }
      return result;
    } else {
      return false;
    }
  }

  public async phoneBlacklist() {
    const phones = this.phones?.split(',');

    if (phones) {
      phones.forEach(async (phoneModel) => {
        let data: { Address: string; MessageType: NotifyType };
        if (typeof phoneModel != undefined && phoneModel) {
          phoneModel = this.refs.util.removeMask(phoneModel);
          data = {
            Address: phoneModel,
            MessageType: NotifyType.Sms,
          };
          this.blacklistPhoneSms = await this.refs.modules.notify.BlacklistExists(
            data
          );

          data = {
            Address: phoneModel,
            MessageType: NotifyType.Whatsapp,
          };
          this.blacklistPhoneWhatsapp = await this.refs.modules.notify.BlacklistExists(
            data
          );

          data = {
            Address: phoneModel,
            MessageType: NotifyType.Rcs,
          };
          this.blacklistPhoneRcs = await this.refs.modules.notify.BlacklistExists(
            data
          );

          if (
            this.blacklistPhoneSms ||
            this.blacklistPhoneWhatsapp ||
            this.blacklistPhoneRcs
          ) {
            if (this.blacklistPhoneSms) {
              this.dataPhoneSms.Value = phoneModel;
              this.dataPhoneSms.MessageType = NotifyType.Sms;
            }
            if (this.blacklistPhoneWhatsapp) {
              this.dataPhoneWhatsapp.Value = phoneModel;
              this.dataPhoneWhatsapp.MessageType = NotifyType.Whatsapp;
            }
            if (this.blacklistPhoneRcs) {
              this.dataPhoneRcs.Value = phoneModel;
              this.dataPhoneRcs.MessageType = NotifyType.Rcs;
            }
          }
        } else {
          this.blacklistPhoneSms = false;
          this.blacklistPhoneWhatsapp = false;
          this.blacklistPhoneRcs = false;
        }
      });
    }
  }

  public async cellPhoneBlacklist() {
    const cellPhones = this.cellphones?.split(',');
    if (cellPhones) {
      cellPhones.forEach(async (cellPhoneModel) => {
        let data: { Address: string; MessageType: NotifyType };
        if (typeof cellPhoneModel != undefined && cellPhoneModel) {
          cellPhoneModel = cellPhoneModel = this.refs.util.removeMask(
            cellPhoneModel
          );
          data = {
            Address: cellPhoneModel,
            MessageType: NotifyType.Sms,
          };
          this.blacklistCellPhoneSms = await this.refs.modules.notify.BlacklistExists(
            data
          );

          data = {
            Address: cellPhoneModel,
            MessageType: NotifyType.Whatsapp,
          };
          this.blacklistCellPhoneWhatsapp = await this.refs.modules.notify.BlacklistExists(
            data
          );
          data = {
            Address: cellPhoneModel,
            MessageType: NotifyType.Rcs,
          };
          this.blacklistCellPhoneRcs = await this.refs.modules.notify.BlacklistExists(
            data
          );
          if (this.blacklistCellPhoneSms) {
            this.dataCellPhoneSms.Value = cellPhoneModel;
            this.dataCellPhoneSms.MessageType = NotifyType.Sms;
          }
          if (this.blacklistCellPhoneWhatsapp) {
            this.dataCellPhoneWhatsapp.Value = cellPhoneModel;
            this.dataCellPhoneWhatsapp.MessageType = NotifyType.Whatsapp;
          }
          if (this.blacklistCellPhoneRcs) {
            this.dataCellPhoneRcs.Value = cellPhoneModel;
            this.dataCellPhoneRcs.MessageType = NotifyType.Rcs;
          }
        } else {
          this.blacklistCellPhoneSms = false;
          this.blacklistCellPhoneWhatsapp = false;
          this.blacklistCellPhoneRcs = false;
        }
      });
    }
  }
}
